module.exports = __webpack_public_path__ + "img/face-id.526aa244.svg";